export default __webpack_public_path__ + "static/educacao-infantil-74e6881555dc5ba80e0624580eda0862.png";